import { Store } from '../../store/store';
import { StoreNode } from '../../store';

type WarrantUploadFileItemProps = {
  file: File;
};

export class WarrantUploadFileItemState
  extends StoreNode {

  constructor(store: Store, props: WarrantUploadFileItemProps) {
    super(store);

    this.file = props.file;
  }

  readonly file: File;
}
